import { render, staticRenderFns } from "./AuthPage.vue?vue&type=template&id=770a2a2a"
import script from "./AuthPage.vue?vue&type=script&lang=js"
export * from "./AuthPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('770a2a2a')) {
      api.createRecord('770a2a2a', component.options)
    } else {
      api.reload('770a2a2a', component.options)
    }
    module.hot.accept("./AuthPage.vue?vue&type=template&id=770a2a2a", function () {
      api.rerender('770a2a2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/auth/AuthPage.vue"
export default component.exports